export class ImageUploadError extends Error {
  constructor () {
    super('Acesso negado!')
    this.name = 'ImageUploadError'
  }
}
